<script setup lang="ts">
import { defineProps } from 'vue';

const props = defineProps<{
  isActive: boolean;
}>();
</script>

<template>
  <div class="[&_*]:underline-offset-[2px] [&_*]:hover:underline" :class="{ '[&_*]:!no-underline': props.isActive }">
    <slot></slot>
  </div>
</template>
